import { SecondaryColors } from '@picsart/design-system/foundation/colors';

import { useTranslator } from '@picsart/rc/services/localization';
import { sanitize } from '@picsart/growth-rc/old/SanitizeHtml';
import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import iconsMap from 'data/iconsMap';
import { FeatureProps } from './types';
import useStyles from './styles';

const FeatureList = ({ title, description, items = [], clickable = true }: FeatureProps) => {
  const translate = useTranslator();
  const styles = useStyles({ clickable });

  const onClickItem = url => {
    if (clickable) {
      window.location.href = url;
    }
  };

  return (
    <div data-testid="features-list">
      <HorizontalContainer>
        <div className={styles.header}>
          <div className={styles.title}>{translate(title)}</div>
          <div className={styles.desc}>{translate(description)}</div>
        </div>
        <div className={styles.content}>
          {items.map((item, index) => {
            const Icon = iconsMap[item.icon] || <></>;
            return (
              <div
                key={index}
                className={styles.item}
                onClick={() => onClickItem(item.url)}
                role="presentation"
              >
                <div className={styles.itemIcon}>
                  <Icon fill={SecondaryColors.base.default} />
                </div>
                <div className={styles.itemInfo}>
                  <div className={styles.itemTitle}>{translate(item.title)}</div>
                  <div className={styles.itemDesc}>
                    {clickable ? (
                      sanitize(translate(item.description), { USE_PROFILES: { html: false } })
                    ) : (
                      // ignore dangerouslySetInnerHTML
                      // eslint-disable-next-line
                    <div dangerouslySetInnerHTML={{__html: translate(item.description)}}></div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </HorizontalContainer>
    </div>
  );
};

export default FeatureList;
